/**
 * API Web Store Registry - 統一所有 scope 的 store
 *
 * 這個 registry 包含所有 member, admin, main 等 scope 需要的 stores
 * 目的是讓 API 以 model 為核心，api_scope 只是視角
 */

import { useAdminStore } from "@modelStores/admin-store";
import { useMemberStore } from "@modelStores/member-store";
import { useSitePageStore } from "@modelStores/site_page-store";
import { useCountryStore } from "@modelStores/country-store";
import { useCourseStore } from "@modelStores/course-store";
import { useEventStore } from "@modelStores/event-store";
import { useNewsArticleStore } from "@modelStores/news-article-store";
import { useLeaderStore } from "@modelStores/leader-store";
import { usePropertyStore } from "@modelStores/property-store";
import { useContactStore } from "@modelStores/contact-store";
import { useExchangeReportStore } from "@modelStores/exchange_report-store";
import { useNotificationStore } from "@modelStores/notification-store";
import { useInmailStore } from "@modelStores/inmail-store";

const storeRegistry: Record<string, () => unknown> = {
  admins: useAdminStore,
  members: useMemberStore,
  sitePages: useSitePageStore,
  countries: useCountryStore,
  courses: useCourseStore,
  events: useEventStore,
  newsArticles: useNewsArticleStore,
  leaders: useLeaderStore,
  properties: usePropertyStore,
  contacts: useContactStore,
  exchangeReports: useExchangeReportStore,
  notifications: useNotificationStore,
  inmails: useInmailStore,
};

export function getStore(storeName: string) {
  const store = storeRegistry[storeName];
  if (!store) {
    console.warn(
      `[API Web Store Registry] Store "${storeName}" not found in the registry.`,
    );
    return;
  }
  return store();
}

export default storeRegistry;
